"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruffleColors = void 0;
exports.TruffleColors = {
    /**
     * Ganache orange
     */
    porsche: "#e4a663",
    /**
     * Truffle blue/turquoise
     */
    turquoise: "#3fe0c5",
    /**
     * Infura orange
     */
    infura: "#ff6b4a"
};
//# sourceMappingURL=index.js.map